import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-dams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-dams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationLocationDamsConstants } from "./create-application-location-dams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { debounceTime } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationLocationDamsComponent = class CreateApplicationLocationDamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    modalService;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationDamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationDamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationDamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationDamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationDamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationDamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationDamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationDamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationDamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationDamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationDamsConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationDamsConstants.OWNER_CONTROL;
    cadastralDescriptionControl = CreateApplicationLocationDamsConstants.CADASTRAL_DESCRIPTION_CONTROL;
    rateNumberControl = CreateApplicationLocationDamsConstants.RATE_NUMBER_CONTROL;
    existingUseControl = CreateApplicationLocationDamsConstants.EXISTING_USE_CONTROL;
    worthyOfPreservationControl = CreateApplicationLocationDamsConstants.WORTHY_OF_PRESERVATION_CONTROL;
    reasonControl = CreateApplicationLocationDamsConstants.REASON_CONTROL;
    over60Control = CreateApplicationLocationDamsConstants.OVER_60_CONTROL;
    amafaPermissionControl = CreateApplicationLocationDamsConstants.AMAFA_PERMISSION_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationDamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationDamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationDamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationDamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationDamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationDamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    cadastralDescriptionTextPlaceHolder = CreateApplicationLocationDamsConstants.CADASTRAL_DESCRIPTION_TEXT_PLACEHOLDER;
    rateNumberTextPlaceHolder = CreateApplicationLocationDamsConstants.RATE_NUMBER_TEXT_PLACEHOLDER;
    existingUseTextPlaceHolder = CreateApplicationLocationDamsConstants.EXISTING_USE_TEXT_PLACEHOLDER;
    worthyOfPreservationTextPlaceHolder = CreateApplicationLocationDamsConstants.WORTHY_OF_PRESERVATION_TEXT_PLACEHOLDER;
    reasonTextPlaceHolder = CreateApplicationLocationDamsConstants.REASON_TEXT_PLACEHOLDER;
    over60TextPlaceHolder = CreateApplicationLocationDamsConstants.OVER_60_TEXT_PLACEHOLDER;
    amafaPermissionTextPlaceHolder = CreateApplicationLocationDamsConstants.AMAFA_PERMISSION_TEXT_PLACEHOLDER;
    ownerLabel = CreateApplicationLocationDamsConstants.OWNER_LABEL;
    copyApplicantToOwnerLabel = CreateApplicationLocationDamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationDamsConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owners";
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = LookupConstants.YES_NO;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    modalOptions = CreateApplicationLocationDamsConstants.MODAL_OPTION;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, modalService, mapService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.modalService = modalService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
        }
        else {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationDamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                cadastralDescription: new FormControl(null, [Validators.required]),
                rateNumber: new FormControl(null, [Validators.required]),
                existingUse: new FormControl(null, [Validators.required]),
                worthyOfPreservation: new FormControl(null, [Validators.required]),
                reason: new FormControl(null, [Validators.required]),
                over60: new FormControl(null, [Validators.required]),
                amafaPermission: new FormControl(null, [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1))
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationDamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                id: 0,
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationDamsConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.handleAddProperty(newProperty);
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            this.handleAddProperty(newProperty);
        }
    }
    handleAddProperty(newProperty) {
        const propertyControl = this.getProperties();
        propertyControl.clear();
        propertyControl.push(newProperty);
        this.active = 0;
        this.updateRequiredFields(0);
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries();
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Demolition management graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).pipe(takeUntil(this._destroy$), take(1)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Demolition management graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    selectYesOrNo(index) {
        if (this.getProperties().controls[index].get(this.over60Control).value?.toLowerCase() === "yes" || this.getProperties().controls[index].get(this.worthyOfPreservationControl).value?.toLowerCase() === "yes") {
            this.getProperties().controls[index].get(this.amafaPermissionControl).addValidators([Validators.required]);
        }
        else {
            this.getProperties().controls[index].get(this.amafaPermissionControl).removeValidators([Validators.required]);
            this.getProperties().controls[index].get(this.amafaPermissionControl).reset();
            this.getProperties().controls[index].updateValueAndValidity();
        }
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationDamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-dams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationDamsComponent);
export { CreateApplicationLocationDamsComponent };
